// Admin email domains for role checking
export const ADMIN_EMAIL_DOMAINS = [
    '@campusmeds.com',
    '@inpstockrx.com'
];
// Default pagination and limits
export const DEFAULT_PAGINATION_LIMIT = 50;
export const MAX_MEDICATIONS_FREE_TIER = 3;
export const MAX_MEDICATIONS_PRO_TIER = 100;
// SMS and notification constants
export const SMS_FROM_NUMBER = process.env.TWILIO_PHONE_NUMBER || '+1234567890';
// Firebase collection names
export const COLLECTIONS = {
    USERS: 'users',
    MEDICATIONS: 'medications',
    TASKS: 'tasks',
    HEALTH: '_health'
};
